import { render, staticRenderFns } from "./ProcurementList.vue?vue&type=template&id=42732c65&scoped=true&"
import script from "./ProcurementList.vue?vue&type=script&lang=js&"
export * from "./ProcurementList.vue?vue&type=script&lang=js&"
import style0 from "./ProcurementList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProcurementList.vue?vue&type=style&index=1&id=42732c65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42732c65",
  null
  
)

export default component.exports